import { render, staticRenderFns } from "./OfferSuccessPage.vue?vue&type=template&id=0a710f51"
import script from "./OfferSuccessPage.vue?vue&type=script&lang=js"
export * from "./OfferSuccessPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports